<template>
  <div class="register-container">
    <img class="logo" src="@/assets/logo.svg" alt="Clavo" width="153" height="33" @click="login" />
    <div class="register-header">
      <div v-if="stage == 'register' || 'checkEmail'">
        <span class="header-text">Have an account?</span>
        <button class="clavo-button secondary" @click="login">
          {{ $t('signIn') }}
        </button>
      </div>
    </div>

    <div class="form-wrapper">
      <form v-if="stage == 'register'" class="register" @submit.prevent="">
        <h1>{{ registerTittle }}</h1>
        <p class="subtitle">
          {{ $t('weWillSendYouAnEmailToConfirmAddress') }}
        </p>

        <editable-input
          id="email"
          :ref="'emailInput'"
          v-model="email"
          autofocus
          lazy-validation
          name-to-save="email"
          :editable-autocomplete="'off'"
          :incorrect-value-msg="$t('invalidEmail')"
          :validation-function="emailValid"
          :title="$t('emailAddress')"
          @focus-out="
            () => {
              if (email !== '') $refs.emailInput.validate()
            }
          "
        />
        <!-- <input type="email" id="email" v-model="email" required autofocus /> -->
        <!-- <p class="alert-warning">{{ error_msg }}</p>  -->
        <button class="clavo-button primary big" :class="{ inactive: isLoading }" @click="register()">
          {{ $t('confirmEmail') }}
        </button>

        <p class="terms-note">
          {{ $t('byContinuingYouReAgreeingToOur') }}
          <a href="https://clavo.app/TOS" target="_blank" class="clavo-link primary">{{ $t('termsOfService') }}</a> and&nbsp;<a
            href="https://clavo.app/privacy"
            target="_blank"
            class="clavo-link primary"
            >{{ $t('privacyPolicy') }}</a
          >.
        </p>
      </form>

      <div v-if="stage == 'checkEmail'" class="check-email">
        <div>
          <h1>{{ $t('checkYourEmail') }}</h1>
          <p>
            {{ $t('toConfirmEmailTapTheButton') }} <strong>{{ email }}</strong
            >.
          </p>
          <p>
            {{ $t('wrongMail') }}
            <a href="" class="clavo-link primary" @click.prevent="stage = 'register'">{{ $t('reenterYourMail') }}</a
            >.
          </p>
        </div>
        <div class="illustration">
          <img src="@/assets/illustrations/email_pic.svg" alt="Please check your email" />
        </div>
      </div>

      <form v-if="stage === 'createAccount'" class="register create-account" @submit.prevent="">
        <h1>{{ createAccountTitle }}</h1>
        <p class="subtitle">
          {{ $t('pleaseEnterYourFullNameOrANick') }}
        </p>
        <editable-input
          id="username"
          v-model="hiddenEmail"
          name-to-save="email"
          editable-autocomplete="off"
          :style="{ visibility: 'hidden', position: 'absolute' }"
          input-type="text"
          :title="$t('emailAddress')"
        />
        <!-- <editable-input
          id="pass"
          v-model="password"
          :name-to-save="'new-password'"
          :style="{visibility: 'hidden',position: 'absolute'}"
          input-type="password"
          lazy-validation
        /> -->
        <editable-input
          id="fullname"
          v-model="fullname"
          input-type="text"
          name-to-save="cc-name"
          editable-autocomplete="cc-name"
          auto-capitalize="words"
          autofocus
          :title="$t('fullName')"
        />
        <editable-input
          id="password"
          :ref="'createPassword'"
          v-model="password"
          input-type="password"
          name-to-save="new-password"
          :class="{ 'animation-shake': errorShake }"
          :validation-function="passwordValid"
          :title="$t('password')"
          lazy-validation
          :incorrect-value-msg="$t('errors.passwordDoesntMeetTheSecurityRequirements')"
          @focus-out="
            () => {
              if (password !== '') $refs.createPassword.validate()
            }
          "
        />
        <p>{{ $t('passwordMustBeAtLeast') }}</p>

        <button class="clavo-button primary big" :class="{ inactive: isLoading }" @click="create_account()">
          {{ $t('createAccount') }}
        </button>
      </form>

      <form v-if="stage === 'simpleRegistration'" class="register create-account" @submit.prevent="">
        <h1>{{ $t('joinXTeam', { x: teamName }) }}</h1>
        <p class="subtitle">
          {{ $t('pleaseEnterYourFullNameOrANick') }}
        </p>

        <editable-input id="sr-fullname" v-model="srFullname" input-type="text" name-to-save="name" required autofocus :title="$t('fullName')" />

        <editable-input
          id="sr-password"
          :ref="'srPassword'"
          v-model="srPassword"
          input-type="password"
          :validation-function="passwordValid"
          :title="$t('password')"
          lazy-validation
          :incorrect-value-msg="$t('invalidPassword')"
          @focus-out="validateSrPassword('srPassword')"
        />

        <p>{{ $t('passwordMustBeAtLeast') }}</p>
        <button class="clavo-button primary big" @click="confirmSimpleRegistration()">
          {{ $t('createAccount') }}
        </button>

        <p>
          {{ $t('byContinuingYouReAgreeingToOur') }}
          <a href="https://clavo.aap/terms" target="_blank" class="clavo-link primary">{{ $t('termsOfService') }}</a> {{ $t('and') }}&nbsp;<a
            href="https://clavo.app/Privacy"
            target="_blank"
            class="clavo-link primary"
            >{{ $t('privacyPolicy') }}</a
          >.
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import Parse from 'parse'
import Validation from '@/components/Validation'
import ParseFunctions from '@/components/ParseFunctions'
import EditableInput from '@/components/UI/EditableInput'
import Constants from '../components/Constants'

export default {
  components: {
    EditableInput,
  },
  mixins: [Validation, ParseFunctions, Constants],
  data() {
    return {
      email: '',
      fullname: '',
      password: '',
      error_msg: '',
      stage: 'register', // register
      token_id: null,
      srFullname: '',
      srPassword: '',
      srTimezone: '',
      teamName: '',
      checkMailInterval: null,
      hiddenEmail: '',
      createAccountTitle: this.$t('createAccount'),
      registerTittle: this.$t('signUpWithEmail'),
      errorShake: false,
      checkingMail: false,
      isLoading: false,
    }
  },
  watch: {
    isLoading: function () {
      this.$store.commit('setShowProgressBar', this.isLoading)
    },
  },
  async mounted() {
    window.addEventListener('blur', this.blur)
    window.addEventListener('focus', this.focus)
    if (this.$route.query.action === 'simple-registration') {
      this.stage = 'simpleRegistration'
    } else if (this.$route.query.action === 'register-from-link' || this.$route.query.action === 'register') {
      this.stage = 'createAccount'
      this.hiddenEmail = this.$route.query.email
      let invitationToken = this.$route.query['team-invitation-url-token']
      if (invitationToken) {
        let res = await this.checkInvitedUser(undefined, invitationToken)
        this.createAccountTitle = this.$t('joinXTeam', { x: res.teamName })
      }
    } else if (this.$route.query.action === 'magic-link') {
      let res = await this.checkInvitedUser(undefined, this.$route.query.token)
      if (res.status === 'ok') {
        this.registerTittle = this.$t('pleaseEnterYourEmailToJoinX', { x: res.teamName })
      } else {
        await this.$router.push('/login')
        this.showServerError(res)
      }
    }
    if (this.$route.query.teamName) {
      this.teamName = this.$route.query.teamName
    }
  },

  beforeDestroy() {
    window.removeEventListener('blur', this.blur)
    window.removeEventListener('focus', this.focus)
    this.stopMailChecking()
  },
  async created() {},
  methods: {
    async check_if_email_confirmed() {
      let res = await this.checkIfEmailConfirmed(this.email, this.token_id)

      if (res.status === 'ok') {
        if (res.userExists) {
          this.stopMailChecking()
          await Parse.User.logInWith('ClavoTokenAuth', { authData: { id: res.token } })
          this.$router.push('/')
        }
      }
    },
    async register() {
      if (this.isLoading) return // block double click
      this.isLoading = true
      if (this.$refs.emailInput.validate()) {
        try {
          let res
          try {
            if (Parse.User.current()) {
              await this.parseLogout()
            }
          } catch (le) {}
          if (this.$route.query.action === 'invitation-link') {
            res = await this.magicLink(this.email, this.$route.query['invitation-token'])
          } else if (this.$route.query.action === 'magic-link') {
            res = await this.magicLink(this.email, undefined, this.$route.query.token)
          } else {
            res = await this.magicLink(this.email)
          }

          // console.log('register magic link res', res)

          if (res.status !== 'ok') {
            this.error_msg =
              "We could not validate your email. Please make sure it's valid, and if the problem persists please write us at support@clavo.app. We apologize for the inconvenience."
          } else {
            this.token_id = res.tokenId
            this.stage = 'checkEmail'
            this.startMailChecking()
            await this.$router.push({
              name: 'Register',
              query: {
                stage: 'checkEmail',
              },
            })
          }
        } catch (e) {
          console.error('register error', e)
          this.error_msg =
            "We were unable to connect to our server. Please make sure you're online, and if the problem persists please write us at support@clavo.app. We apologize for the inconvenience."
        }
      }
      this.isLoading = false
    },
    blur() {
      this.stopMailChecking(true)
    },
    focus() {
      if (this.checkingMail) {
        this.startMailChecking()
      }
    },
    startMailChecking() {
      if (!this.checkMailInterval) {
        this.checkingMail = true
        this.check_if_email_confirmed()
        this.checkMailInterval = window.setInterval(() => {
          this.check_if_email_confirmed()
        }, 3000)
      }
    },
    stopMailChecking(skipClearingState = false) {
      if (!skipClearingState) {
        this.checkingMail = false
      }
      if (this.checkMailInterval) {
        window.clearInterval(this.checkMailInterval)
        this.checkMailInterval = null
      }
    },
    async create_account() {
      if (this.isLoading) return // block double click
      this.isLoading = true
      if (this.password !== '' && this.$refs.createPassword.validate()) {
        try {
          // let user = new Parse.User()
          let email = this.$route.query.email
          let fullName = this.fullname
          let password = this.password
          let token = this.$route.query.token
          let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
          let locale = navigator.language //

          let res = await this.SignUpClavoUser(email, fullName, password, timezone, token, locale)
          if (res.status === 'ok') {
            await Parse.User.logIn(this.$route.query.email, this.password)
          } else {
            this.showServerError(e)
            this.isLoading = false
            return
          }
        } catch (e) {
          this.showServerError(e)
          this.isLoading = false
          return
        }
        let query = this.$route.query
        if (query) {
          let token = query['team-invitation-url-token'] ? query['team-invitation-url-token'] : query['token']
          if (token) {
            await this.acceptInvitation(token)
          } else {
            await this.$router.push('/onboarding')
          }
        } else {
          await this.$router.push('/onboarding')
        }
      } else {
        this.errorShake = true
        setTimeout(
          function () {
            this.errorShake = false
          }.bind(this),
          500,
        )
      }
      this.isLoading = false
    },
    async acceptInvitation(token) {
      let res = await this.addTeamMemberByUrl(token)
      await this.$router.push({
        path: '/',
        query: { msg: 'youHaveAcceptedInvitation' },
      })
    },
    login() {
      let query = this.$route.query
      this.$router.push({ path: '/login', query: query })
    },
    home() {
      window.open('https://clavo.app', '_self')
    },
    async confirmSimpleRegistration() {
      this.$refs.srPassword.validate()
      var moment = require('moment-timezone')

      this.srTimezone = moment.tz.guess()
      let res = await this.overwriteAccount(this.$route.query.email, this.srFullname, this.srPassword, this.srTimezone, this.$route.query.token)
      if (res.status === 'ok') {
        await Parse.User.logIn(this.$route.query.email, this.srPassword)
        res = await this.confirmTeamMember(this.$route.query.email, this.$route.query.token)
        // console.log('confirmTeamMember res: ', res)
        await this.$router.push({
          path: '/',
          query: {
            newTeamMember: 'welcomePopup',
            teamId: this.$route.query.teamId,
          },
        })
      } else {
        this.showServerError(res)
      }
    },
    validateSrPassword() {
      if (this.srPassword !== '') {
        this.$refs.srPassword.validate()
      }
    },
  },
}
</script>

<style lang="scss">
// Use big inputs
#app .register-container {
  @include input-big;
}
</style>

<style lang="scss" scoped>
.register-container {
  display: flex;
  flex-direction: column;

  .logo {
    align-self: flex-start;
    order: 0;
    margin: 30px;
    cursor: pointer;
  }
  .register-header {
    align-self: flex-end;
    margin: -66px 30px 24px 30px;

    .header-text {
      font-size: 16px;
      line-height: 24px;
      margin-right: 30px;
      font-family: $regular;
      @include respond-below(sm) {
        display: none;
      }
      @include respond-below(xs) {
        display: block;
        margin-right: 0;
        width: 100%;
        text-align: center;
      }
    }

    @include respond-below(xs) {
      order: 2;
      margin-top: 0;
      align-self: center;
      width: 100%;
      padding: 0 30px;

      button {
        width: 100%;
        margin: 18px 0;
      }
    }
  }

  .form-wrapper {
    max-width: 960px;
    width: 100%;
    padding: 0 30px;
    margin: 100px auto 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    @include respond-below(xs) {
      margin-top: 48px;
      padding-bottom: 96px;
    }

    form:last-child {
      margin-bottom: 48px;
    }
  }

  form.register {
    width: 50%;
    // margin-top: 100px;
    @include respond-below(sm) {
      width: 100%;
    }
    * {
      margin-bottom: 24px;
    }

    h1 {
      margin-bottom: 12px;
    }

    p {
      margin-top: 10px;
      margin-bottom: 30px;
      font-family: $regular;
      line-height: 20px;
      &.subtitle {
        font-size: 16px;
        font-family: $regular;
        line-height: 24px;
        margin-bottom: 48px;
      }
    }

    .terms-note a {
      white-space: nowrap;
    }

    button {
      margin-top: 36px;
      margin-bottom: 36px;

      @include respond-below(md) {
        width: 100%;
      }
    }
  }
  .check-email {
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      flex: 1;
      h1 {
        margin-bottom: 12px;
      }
      p {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 24px;
        &:last-of-type {
          // margin-bottom: 96px;
        }
      }
      &.illustration {
        text-align: center;
        img {
          height: 260px;
          margin: 0px 0 0 24px;
        }
      }
    }

    @include respond-below(sm) {
      flex-direction: column-reverse;
      align-items: flex-start;
      div.illustration {
        // display: none;
        text-align: left;
        img {
          margin: 0 0 24px 0;
          height: 84px;
        }
      }
    }
  }
}
.animation-shake {
  animation: shake 0.5s linear;
  animation-iteration-count: infinite;
}
</style>
